import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LOCALES } from "../../../constants";
import { loadData } from "../../../functions/dataLoader";
import { getPotentialBgKey } from "../../../functions/getPotentialFunctions";
import FILTERS from "../../../config/filter_config.json";

const normalizePotentials = (originData, saviors) => {
    const entities = {};
    const ids = [];

    originData.forEach((potential) => {
        ids.push(potential.id);

        const unitName = potential.unitId && potential.unitId !== 0 ? saviors.find((s) => s.id === potential.unitId)?.name : null;

        const parts = [potential.name[LOCALES.KO], potential.desc[LOCALES.KO]];
        const parts_ENG = [potential.name[LOCALES.EN], potential.desc[LOCALES.EN]];

        (potential.levels ?? []).forEach((level) => {
            parts.push(level.desc[LOCALES.KO]);
            parts_ENG.push(level.desc[LOCALES.EN]);
        });

        entities[potential.id] = {
            ...potential,
            unitName,
            bgKey: getPotentialBgKey(potential),
            searchText: parts.join(" "),
            searchText_ENG: parts_ENG.join(" "),
        };
    });

    ids.sort((a, b) => {
        if (entities[a].type !== entities[b].type) return entities[a].type === "일반 잠재력" ? -1 : 1;
        return entities[a].name[LOCALES.KO].localeCompare(entities[b].name[LOCALES.KO], LOCALES.KO);
    });

    return { ids, entities };
};

export const initPotentials = createAsyncThunk("potentials/init", async () => {
    const [originData, saviors] = await Promise.all([loadData("potentials.json"), loadData("saviors.json")]);
    return normalizePotentials(originData, saviors);
});

const potentialSlice = createSlice({
    name: "potentials",
    initialState: {
        ids: [],
        entities: {},
        filter: {
            potential_type: FILTERS.POTENTIAL_TYPE[0],
            potential_role: FILTERS.CLASS[0],
        },
        status: "idle",
    },
    reducers: {
        changeFilter: (state, action) => {
            state.filter[action.payload.id] = action.payload.obj;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initPotentials.fulfilled, (state, action) => {
            state.ids = action.payload.ids;
            state.entities = action.payload.entities;
            state.status = "done";
        });
    },
});

export const { changeFilter } = potentialSlice.actions;
export default potentialSlice.reducer;
